import axios from "axios";
import { Urls } from "../../App";

export const useAgentDashboardService = () => {
  //const baseURL = "https://devapi.maxlifeinsurance.com/acr"; // DEV
  // const baseURL = "https://uatapi.maxlifeinsurance.com/acr"; //UAT
  const { baseURL, APIKey } = Urls();
  const URL = baseURL;
  const fetchDashboardDetails = async (options) => {
    try {
      const { body, token } = options;
      const config = {
        headers: {
          Token: `Bearer ${token}`,
          "Content-Type": "application/json",
          //"x-api-key": "U1HQLHNvZO8ewIKnaZEIv95fvF4zDfEu3h9aLuAI", //dev
          // "x-api-key": "aDOZwp6VeM74RDuuQFgpRVZAoVdjul5Dppz2Oh30", //uat
          "x-api-key": APIKey,
        },
      };
      const response = await axios.post(
        `${URL}/api/dashboard/fetch`,
        body,
        config
      );
      return await response.data;
    } catch (error) {
      return null;
    }
  };
  return { fetchDashboardDetails };
};
